import { PageHeader } from '@/components/shared';
import { useBackofficePageTitle } from '@/lib/page-title';
import { DeveloperToolCard } from './components';

export function BackofficeDeveloperPage() {
  useBackofficePageTitle('Developer');

  return (
    <main className="min-h-[320px] bg-white p-6 md:p-8" aria-label="Backoffice main content">
      <div className="flex max-w-3xl flex-col gap-5">
        <div>
          <PageHeader showShareButton={false}>Developer</PageHeader>
          <p className="mt-2 text-body text-neutral-600">
            Developer tools for inspecting and operating Nava services.
          </p>
        </div>
        <DeveloperToolCard />
      </div>
    </main>
  );
}
